<template>
  <div class="chart-bar-o" v-loading="loading" element-loading-background="rgba(0, 0, 0, 0.5)">
    <!-- <div class="title">
      <span>{{ title }}</span>
      <ElementSelect
        :val="year"
        @val="
          (e) => {
            year = e;
          }
        "
      />
    </div> -->
    <div class="chart-con unsetover">
      <div v-for="(item, index) in itemList" :class="'item item-' + index" @click="showModal(index, item)">
        <template v-if="typeof item.label === 'string'">
          <div class="item-label">{{ item.label }}</div>
          <div class="item-value" v-if="item.key === 'five_good'">
            <span>全国</span><b>{{ dataArr['national_five_good_amount'] || '-' }}</b
            ><span>{{ item.unit }}</span>
              <span>省</span><b>{{ dataArr['province_five_good_amount'] || '-' }}</b
            ><span>{{ item.unit }}</span>
          </div>
          <div class="item-value" v-else="">
            <b>{{ dataArr[item.key] || '-' }}</b
            ><span>{{ item.unit }}</span>
          </div>
        </template>
        <template v-else>
          <div class="line" v-for="(line, i) in item.label">
            <div class="item-label">{{ line }}</div>
            <div class="item-value">
              <b>{{ dataArr[item.key[i]] || '-' }}</b
              ><span>{{ item.unit }}</span>
            </div>
          </div>
        </template>
      </div>
    </div>
    <EleDialog id="org_dev" title="全省各级工商联组织发展情况" :visible.sync="showOrgDev" width="30%"
      class="org-dev">
      <el-row :gutter="20">
        <div class="item-label">
          全省各级工商联组织数: <b>{{orgDev.total || '-'}}</b>
        </div>

      </el-row>
      <el-row :gutter="20" style="padding-top: 10px">
        <div class="sub-title">
          <span>县级以上工商联设立情况</span>
        </div>
      </el-row>
      <el-row :gutter="20" style="padding-top: 10px; padding-left: 10px">
        <el-col :span="6">
          <div class="item-label">
            省级工商联
          </div>
        </el-col>

        <el-col :span="8">
          <div class="item-label">
            地级以上市工商联
          </div>
        </el-col>
        <el-col :span="10">
          <div class="item-label">
            县级工商联
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="20" style="padding-top: 10px; padding-left: 10px">
        <el-col :span="6">
          <div class="item-label cursor-pointer" @click="getOrgInfoData(0, true)">
            {{orgDev.province_industry_commerce_federation_ || '-'}} 个
          </div>
        </el-col>
        <el-col :span="8">
          <div class="item-label cursor-pointer" @click="getOrgInfoData(1, true)">
            {{orgDev.above_prefecture_level_amount || '-'}} 个
          </div>
        </el-col>
        <el-col :span="10">
          <div class="item-label cursor-pointer"  @click="getOrgInfoData(2, true)">
            {{orgDev.county_amount || '-'}} 个<span
              class="comment-font"> (含功能区工商联)
          </span>
          </div>
        </el-col>
      </el-row>
    </EleDialog>
    <EleDialog id="org_info" title="工商联组织详情" :visible.sync="orgInfoShow" class="org-info">
      <el-row>
        <el-col :span="5">
          <div class="item-label text-align-right">
            组织名称
          </div>
        </el-col>
        <el-col :span="7" style="padding-left: 10px">
          <div class="item-label">
            {{orgInfo.organization_name || '-'}}
          </div>
        </el-col>
        <el-col :span="5">
          <div class="item-label text-align-right">
            上级组织名称
          </div>
        </el-col>
        <el-col :span="7" style="padding-left: 10px">
          <div class="item-label">
            {{orgInfo.parent_organization_name || '-'}}
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="5">
          <div class="item-label text-align-right">
            机构编码
          </div>
        </el-col>
        <el-col :span="7" style="padding-left: 10px">
          <div class="item-label">
            {{orgInfo.organization_code || '-'}}
          </div>
        </el-col>
        <el-col :span="5">
          <div class="item-label text-align-right">
            录入年份
          </div>
        </el-col>
        <el-col :span="7" style="padding-left: 10px">
          <div class="item-label">
            {{orgInfo.data_year || '-'}}
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="5">
          <div class="item-label text-align-right">
            行政级别
          </div>
        </el-col>
        <el-col :span="7" style="padding-left: 10px">
          <div class="item-label">
            {{orgInfo.administrative_level || '-'}}
          </div>
        </el-col>
        <el-col :span="5">
          <div class="item-label text-align-right">
            电子邮箱
          </div>
        </el-col>
        <el-col :span="7" style="padding-left: 10px">
          <div class="item-label">
            {{orgInfo.email || '-'}}
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="5">
          <div class="item-label text-align-right">
            联系电话
          </div>
        </el-col>
        <el-col :span="7" style="padding-left: 10px">
          <div class="item-label">
            {{orgInfo.phone || '-'}}
          </div>
        </el-col>
        <el-col :span="5">
          <div class="item-label text-align-right">
            传真
          </div>
        </el-col>
        <el-col :span="7" style="padding-left: 10px">
          <div class="item-label">
            {{orgInfo.fax || '-'}}
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="5">
          <div class="item-label text-align-right">
            邮编
          </div>
        </el-col>
        <el-col :span="7" style="padding-left: 10px">
          <div class="item-label">
            {{orgInfo.postal_code || '-'}}
          </div>
        </el-col>
        <el-col :span="5">
          <div class="item-label text-align-right">
            通讯地址
          </div>
        </el-col>
        <el-col :span="7" style="padding-left: 10px">
          <div class="item-label">
            {{orgInfo.communication_address || '-'}}
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="5">
          <div class="item-label text-align-right">
            本级直属个人会员数
          </div>
        </el-col>
        <el-col :span="7" style="padding-left: 10px">
          <div class="item-label">
            {{orgInfo.personal_member_amount || '-'}}
          </div>
        </el-col>
        <el-col :span="5">
          <div class="item-label text-align-right">
            本级直属企业会员数
          </div>
        </el-col>
        <el-col :span="7" style="padding-left: 10px">
          <div class="item-label">
            {{orgInfo.company_member_amount || '-'}}
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="5">
          <div class="item-label text-align-right">
            本级直属团体会员数
          </div>
        </el-col>
        <el-col :span="7" style="padding-left: 10px">
          <div class="item-label">
            {{orgInfo.groups_member_amount || '-'}}
          </div>
        </el-col>
        <el-col :span="5">
          <div class="item-label text-align-right">
            本级直属会员总数
          </div>
        </el-col>
        <el-col :span="7" style="padding-left: 10px">
          <div class="item-label">
            {{orgInfo.under_same_level_member_amount || '-'}}
          </div>
        </el-col>
      </el-row>
    </EleDialog>
    <EleDialog id="org_list" :title="orgListTitle" :visible.sync="orgInfoListShow">
      <div class="filter-box">
        <ElementSelect
            :val="parentName"
            :options="parentSelectList"
            @change="
              (e) => {
                parentName = e;
                searchName = '';
                if(e){
                  let conData =
                  parentSelectList.filter((item) => item.value === e)[0].children;
                  this.searchNameSelectList = conData
                } else {
                  this.searchNameSelectList = []
                }
                getOrgInfoData(selectIndex, false);
              }
            "
            size="middle"
            v-if="selectIndex === 2"
            clearable
        />
        <ElementSelect
            :val="searchName"
            :options="searchNameSelectList"
            @change="
              (e) => {
                searchName = e;
                getOrgInfoData(selectIndex, false);
              }
            "
            size="middle"
            v-if="selectIndex === 1 || selectIndex === 2"
            clearable
        />
      </div>
      <el-table
          :data="orgInfoList"
          style="width: 100%;margin-bottom: 20px;;overflow:unset"
          row-key="organization_name"
          border
          default-expand-all
          :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
          height="60%"
          @cell-click="orgListCellClick">
        <el-table-column
            prop="organization_name"
            label="工商联名称">
        </el-table-column>
        <el-table-column
            prop="phone"
            label="联系电话">
        </el-table-column>
        <el-table-column
            prop="fax"
            label="传真">
        </el-table-column>
        <el-table-column
            prop="email"
            label="电子邮箱">
        </el-table-column>
        <el-table-column
            prop="communication_address"
            label="通讯地址"
            width="180">
        </el-table-column>
      </el-table>
    </EleDialog>
    <EleDialog id="member_dev" title="全省工商联会员发展情况" :visible.sync="memberDevInfoShow"
               class="member-dev" height="100%">
      <el-row :gutter="20" style="padding-left: 10px">
        <el-col :span="6">
          <div class="item-label">
            企业会员
          </div>
          <div class="item-label" style="padding-top: 10px">
            {{ memberDevelopmentData.company_member_amount || '-' }} 个
          </div>
        </el-col>

        <el-col :span="6">
          <div class="item-label">
            团体会员
          </div>
          <div class="item-label" style="padding-top: 10px">
            {{ memberDevelopmentData.groups_member_amount || '-' }} 个
          </div>
        </el-col>
        <el-col :span="6">
          <div class="item-label">
            个人会员
          </div>
          <div class="item-label" style="padding-top: 10px">
            {{ memberDevelopmentData.personal_member_amount || '-' }} 个
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="20" style="">
        <div class="sub-title">
          <span>工商联会员数量位居前五的地市</span>
        </div>
      </el-row>
      <el-row :gutter="20" style="padding-left: 10px">
        <el-col :span="4" v-for="item in memberTopFiveData">
          <div class="item-label">
            {{ item.city || '-' }}
          </div>
          <div class="item-label" style="padding-top: 10px">
            {{ item.member_amount || '-' }} 个
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="20" style="">
        <div class="sub-title">
          <span>工商联会员增幅前三的地市</span>
        </div>
      </el-row>
      <el-row :gutter="20" style="padding-left: 10px">
        <el-col :span="6" v-for="item in memberGrowthTopThreeData">
          <div class="item-label">
            {{ item.city || '-' }}
          </div>
          <div class="item-label"  style="padding-top: 10px">
            {{ item.growth || '-' }} %
          </div>
        </el-col>
      </el-row>
      <el-row :gutter="20" style="">
        <div class="sub-title">
          <span>各地市近3年会员变化情况</span>
        </div>
        <div class="flex-between">
          <TabList :list="memberChangeTabList" :act="memberChangeTabIndex" @clickItem="changeTab" />
          <ElementSelect
              :val="selectMemberChangeThreeYearsCity"
              :options="memberChangeThreeYearsCity"
              @change="
              (e) => {
                selectMemberChangeThreeYearsCity = e;
                getOrgMemberChangeThreeYears();
              }
            "
              size="middle"
          />
        </div>
        <v-chart ref="orgMemberChangeThreeYearsBarChart" id="orgMemberChangeThreeYearsChart"
                 class="bar-chart"
                 :options="memberChangeThreeYearsCityChartOption" width="100%"/>
      </el-row>
    </EleDialog>
    <EleDialog id="worker_list" title="市、县工商联编制人数情况" :visible.sync="workerListShow">
      <div class="filter-box">
        <ElementSelect
            :val="cityEPersonSelectCity"
            :options="cityEPersonCityList"
            @change="
              (e) => {
                cityEPersonSelectCity = e;
                getCityEPerson();
              }
            "
            size="middle"
            clearable
        />
      </div>
      <el-table
          :data="cityEPersonList"
          style="width: 100%;margin-bottom: 20px;overflow:unset"
          row-key="city"
          border
          default-expand-all
          height="60%">
        <el-table-column
            prop="city"
            label="地市">
        </el-table-column>
        <el-table-column
            prop="county_federation_amount"
            label="县级工商联数">
        </el-table-column>
        <el-table-column
            prop="city_actual_worker_amount"
            label="市级实际工作人数">
        </el-table-column>
        <el-table-column
            prop="county_actual_worker_amount"
            label="县级实际工作总人数">
        </el-table-column>
        <el-table-column
            prop="county_avg_worker_amount"
            label="县级平均工作人数">
        </el-table-column>
        <el-table-column
            prop="city_preparation_worker_amount"
            label="市级编制人数">
        </el-table-column>
        <el-table-column
            prop="county_preparation_worker_amount"
            label="县级编制总人数">
        </el-table-column>
        <el-table-column
            prop="county_avg_preparation_amount"
            label="县级平均编制人数">
        </el-table-column>
      </el-table>
    </EleDialog>
    <EleDialog id="five_good_list" title="五好”工商联各地市情况" :visible.sync="fiveGoodListShow"
               class="five-good">
      <el-row :gutter="20" style="padding-left: 10px">
        <el-col :span="12">
          <div class="item-label">
            全国“五好”县级工商联数：<b>{{ nationalFiveGoodTotal || '-' }}</b>
          </div>
        </el-col>
        <el-col :span="12">
          <div class="item-label">
            省“五好”县级工商联数：<b>{{ provincesFiveGoodTotal || '-' }}</b>
          </div>
        </el-col>
      </el-row>
      <div class="flex-between" style="padding-top: 10px; padding-bottom: 10px;">
        <TabList :list="fiveGoodTabList" :act="fiveGoodTabIndex" @clickItem="fiveGoodChangeTab"/>
      </div>
      <el-table
          :data="showFiveTableList"
          style="width: 100%;margin-bottom: 20px;overflow:unset"
          row-key="city"
          border
          default-expand-all
          height="60%">
        <el-table-column
            prop="city"
            label="地市" min-width="100">
        </el-table-column>
        <el-table-column
            prop="county"
            label="区县" min-width="200">
        </el-table-column>
        <el-table-column
            prop="amount"
            label="数量" min-width="80">
        </el-table-column>
        <el-table-column
            prop="proportion"
            label="占比" min-width="80">
        </el-table-column>
      </el-table>
    </EleDialog>
    <EleDialog id="coc_change_three_year" title="各地级以上市近3年镇街商会变化情况"
               :visible.sync="cocChangeThreeYearInfoShow"
               class="coc-change-three-year" height="100%">
      <el-row :gutter="20" style="">
        <div class="flex-between">
          <div class="sub-title">
            <span>近3年镇街商会数</span>
          </div>
          <ElementSelect
              :val="selectCocChangeThreeYearsCity"
              :options="cocChangeThreeYearsCity"
              @change="
              (e) => {
                selectCocChangeThreeYearsCity = e;
                getCocChangeThreeYear();
              }
            "
              size="middle"
          />
        </div>
        <v-chart ref="bar-chart" id="cocChangeThreeYearChart" class="bar-chart"
                 :options="cocChangeThreeYearChartOption" width="100%"/>
      </el-row>
      <el-row :gutter="20" style="">
        <div class="sub-title">
          <span>近3年镇街商会覆盖率</span>
        </div>
            <ComTable
              :tableCol="cocChangeThreeYearCoverTableCol"
              :tableData="cocChangeThreeYearCoverTableData"
              :isPagination="false"
              style="height: 150px"
            />
      </el-row>
    </EleDialog>
    <EleDialog :title="dialogTitle" :visible.sync="showDialog" :class="itemIndex === 2 && 'info-modal'">
<!--      <template v-if="itemIndex === 2">-->
<!--        <div class="item-title" :data-title="curData.c_entname"></div>-->
<!--        <div class="item-content flex-between">-->
<!--          <ul class="content-ul" v-for="ul in dialogUlList">-->
<!--            <li v-for="li in ul">-->
<!--              <div class="li-label">{{ li.label }}</div>-->
<!--              <div class="li-value">{{ itemData[li.key] }}</div>-->
<!--            </li>-->
<!--          </ul>-->
<!--        </div>-->
<!--      </template>-->
      <div v-if="itemIndex === 2" class="item-title" data-title="项目月报"></div>
      <div v-else class="filter-box">
<!--        <ElementSelect-->
<!--          :val="search.city"-->
<!--          :options="optionCity"-->
<!--          @change="-->
<!--            (e) => {-->
<!--              search.city = e;-->
<!--              refreshPage();-->
<!--            }-->
<!--          "-->
<!--          size="middle"-->
<!--        />-->
<!--        <EleInput v-model="search.entName" placeholder="请输入企业名称" clearable />-->
      </div>
<!--      <ComTable-->
<!--        :tableCol="tableCol"-->
<!--        :tableData="tableData"-->
<!--        :pager="pager"-->
<!--        @handleSizeChange="handleSizeChange"-->
<!--        @handleCurrentChange="handleCurrentChange"-->
<!--        :isPagination="itemIndex !== 2"-->
<!--      />-->
    </EleDialog>
    <EleDialog title="企业概况" :visible.sync="showCompany" class="company-profile">
      <CompModal v-if="showCompany" :curData="curData"></CompModal>
    </EleDialog>
  </div>
</template>

<script>
// import drawBar from '../chartJs/bar';
import drawBar from '../chartJs/chartBarAndLine.js';
import drawOneBar from '../chartJs/bar';
import { getBarData } from '@/api/getChartData';
import TabList from '../../../components/tabList';
import ComTable from '../../../components/ComTable';
import CompModal from './CompModal.vue';
import ElementSelect from '../../../components/element-select';
import echarts from 'echarts';
import drawLine from '../chartJs/PELine';
import cityJson from '../cityJson';
import { getTime } from '@/utils/tool';
export default {
  name: 'ChartBar',
  components: { TabList, ElementSelect, ComTable, CompModal },
  props: {
    title: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
    apiName: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: '',
    },
    showLabel: {
      type: Boolean,
      default: false,
    },
    chartId: {
      type: String,
      default: 'bar-chart',
    },
    yearP: {
      type: Number,
      default: 2023,
    },
  },
  data() {
    return {
      itemList: [
        {
          key: 'org_amount',
          label: '全省各级工商联组织数',
          unit: '个',
        },
        {
          key: 'member_amount',
          label: '全省工商联会员总数',
          unit: '个',
        },
        {
          key: 'avg_worker_amount',
          label: '全省地级以上市平均工作人员',
          unit: '名',
        },
        {
          key: 'preparation_worker_amount',
          label: '全省地级以上市编制人数',
          unit: '名',
        },
        {
          key: 'five_good',
          label: '”五好“县级工商联数',
          unit: '个',
        },
        {
          key: 'province_township_chambers_of_commerce_amount',
          label: '全省乡镇（街道）商会数',
          unit: '个',
        },
      ],
      showOrgDev: false,
      orgDev: {},
      orgInfo: {},
      orgInfoList: [],
      orgInfoShow: false,
      orgInfoListShow: false,
      selectIndex: 0,
      parentSelectList: [],
      searchNameSelectList: [],
      parentName: '',
      searchName: '',
      orgListTitle: '',
      memberDevInfoShow: false,
      memberChangeThreeYearsCity: [],
      selectMemberChangeThreeYearsCity: '',
      memberChangeThreeYearsList: [],
      memberGrowthTopThreeData: {},
      memberTopFiveData: {},
      memberDevelopmentData: {},
      memberChangeTabList: [
        {
          key: 0,
          label: '个人'
        },
        {
          key: 1,
          label: '企业'
        },
        {
          key: 2,
          label: '团体'
        }
      ],
      memberChangeTabIndex: 0,
      memberChangeThreeYearsCityChartOption: null,
      workerListShow: false,
      cityEPersonSelectCity: '',
      cityEPersonCityList: [],
      cityEPersonList: [],
      nationalFiveGoodList: [],
      nationalFiveGoodTotal: null,
      provincesFiveGoodList: [],
      provincesFiveGoodTotal: null,
      fiveGoodListShow: false,
      showFiveTableList: [],
      fiveGoodTabList: [
        {
          key: 0,
          label: '全国“五好”县级工商联'
        },
        {
          key: 1,
          label: '广东省“五好”县级工商联'
        }
      ],
      fiveGoodTabIndex: 0,
      cocChangeThreeYearInfoShow: false,
      cocChangeThreeYearChartOption: null,
      selectCocChangeThreeYearsCity: '',
      cocChangeThreeYearsCity: [],
      cocChangeThreeYearsList: [],




      loading: false,

      chartData: null,
      dataArr: {},

      itemIndex: 0,
      year: this.yearP,
      showDialog: false,
      showCompany: false,
      dialogTitle: '',
      tableData: [],
      itemData: null,
      pager: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
      search: {
        city: '全省',
        entName: '',
      },
      optionCity: [
        {
          value: '全省',
          label: '全省',
        },
        ...cityJson,
      ],
      curData: null,
    };
  },
  computed: {
    cocChangeThreeYearCoverTableCol() {
      if (this.cocChangeThreeYearsList) {
        let arr = [];
        for (let i = 0; i < this.cocChangeThreeYearsList.length; i++) {
          let col = {
            label: this.cocChangeThreeYearsList[i].year,
            param: this.cocChangeThreeYearsList[i].year,
          }
          arr.push(col);
        }
        return arr;
      }
    },
    cocChangeThreeYearCoverTableData() {
      if (this.cocChangeThreeYearsList) {
        let arr = [];
        let col = {};
        for (let i = 0; i < this.cocChangeThreeYearsList.length; i++) {
          col[this.cocChangeThreeYearsList[i].year] =
              this.cocChangeThreeYearsList[i].proportion + '%';
        }
        arr.push(col);
        return arr;
      }
    }
  },
  watch: {
    'search.entName'(n) {
      if (!n) {
        this.search.entName = null;
        this.search.id = null;
      }
      this.pager.currentPage = 1;
      this.$nextTick(() => this.refreshPage());
    },
    tabIndex() {
      this.pager = {
        currentPage: 1,
        pageSize: 10,
        total: 0,
      };
    },
    yearP(n) {
      console.log(n, 112233);
      this.year = n;
      this.getData();
    },
  },
  methods: {
    getData() {
      console.log(888, this.year);
      this.$api.member.getOrgProfile({ year: this.year }).then((res) => {
        let { data } = res.data;
        console.log(888, data);
        this.dataArr = data;
        this.loading = false;
      });
    },
    getOrgDevData() {
      console.log(888, this.year);
      this.$api.member.getOrgDevelopment({ year: this.year }).then((res) => {
        let { data } = res.data;
        console.log(888, data);
        this.orgDev = data;
      });
    },
    getOrgInfoData(index, openTag) {
      console.log(888, index);
      if (openTag){
        this.parentName = '';
        this.searchName = '';
        this.searchNameSelectList = [];
        this.parentSelectList = [];
      }
      this.selectIndex = index;
      let administrativeLevel = '县'
      this.orgListTitle = '县级工商联信息'
      if (index === 0){
        administrativeLevel = '省'
      } else if (index === 1) {
        administrativeLevel = '市'
        this.orgListTitle = '地级市以上工商联信息'
      }
      this.$api.member.getOrgBaseInfo({
        year: this.year,
        administrativeLevel: administrativeLevel,
        parentName: this.parentName,
        searchName: this.searchName
      }).then((res) => {
        let { data } = res.data;
        this.orgInfoList = data;
        if (index === 0){
          if (this.orgInfoList){
            this.orgInfo = this.orgInfoList[0]
          }
          this.orgInfoShow = true;
        } else {
          if (this.orgInfoList && !this.parentName && !this.searchName){
            if (index === 1){
              this.searchNameSelectList = this.orgInfoList.map(item => {
                return {
                  label: item.organization_name,
                  value: item.organization_name
                }
              });
            } else {
              this.parentSelectList = this.orgInfoList.map(item => {
                return {
                  label: item.organization_name,
                  value: item.organization_name
                }
              });
              this.parentSelectList.forEach(item => {
                let children = [];
                for (let i = 0; i < this.orgInfoList.length; i++){
                  if (this.orgInfoList[i].children){
                    for (let j = 0; j < this.orgInfoList[i].children.length; j++){
                      if (item.value === this.orgInfoList[i].children[j].parent_organization_name) {
                        let selectData = {
                          label: this.orgInfoList[i].children[j].organization_name,
                          value: this.orgInfoList[i].children[j].organization_name
                        }
                        children.push(selectData);
                      }
                    }
                  }
                }
                item.children = children
              })
              console.log(this.parentSelectList)
            }
          }
          this.orgInfoListShow = true;
        }
      });
    },
    orgListCellClick(row,column,event,cell) {
      this.orgInfo = row;
      this.orgInfoShow = true;
    },
    getMemberDevData() {
      console.log(888, this.year);
      this.$api.member.getMemberDevelopment({ year: this.year }).then((res) => {
        let { data } = res.data;
        console.log(888, data);
        this.memberDevelopmentData = data;
      });
    },
    getMemberTopFiveData() {
      console.log(888, this.year);
      this.$api.member.getMemberTopFive({ year: this.year }).then((res) => {
        let { data } = res.data;
        console.log(888, data);
        this.memberTopFiveData = data;
      });
    },
    getMemberGrowthTopThreeData() {
      console.log(888, this.year);
      this.$api.member.getMemberGrowthTopThree({ year: this.year }).then((res) => {
        let { data } = res.data;
        console.log(888, data);
        this.memberGrowthTopThreeData = data;
      });
    },
    getOrgMemberChangeThreeYears() {
      console.log(888, this.selectMemberChangeThreeYearsCity);
      this.$api.member.getMemberChangeThreeYears({ city: this.selectMemberChangeThreeYearsCity }).then((res) => {
        let { data } = res.data;
        console.log(888, data);
        this.memberChangeThreeYearsList = data;
        this.memberChangeTabIndex = 0;
        this.getOrgMemberChangeThreeYearsChart();
      });
    },
    getOrgMemberChangeThreeYearsChart() {
      let names = ['会员数', '增幅'];
      let list = {
        yAxis: {
          names: ['单位：个', '单位：%'],
        },
        names: Array.from(names),
        data: [],
      };
      list.names = names;
      list.showLabel = true;
      if (this.memberChangeThreeYearsList) {
        for (let i = 0; i < this.memberChangeThreeYearsList.length; i++) {
          if (this.memberChangeThreeYearsList[i].this_year){
            let obj = {};
            obj['年份'] = (this.memberChangeThreeYearsList[i].this_year);
            if (this.memberChangeTabIndex === 0) {
              obj['会员数'] = this.memberChangeThreeYearsList[i].this_personal_member;
              obj['增幅'] = this.memberChangeThreeYearsList[i].personal_member_growth;
            } else if (this.memberChangeTabIndex === 1) {
              obj['会员数'] = this.memberChangeThreeYearsList[i].this_company_member;
              obj['增幅'] = this.memberChangeThreeYearsList[i].company_member_growth;
            } else if (this.memberChangeTabIndex === 2) {
              obj['会员数'] = this.memberChangeThreeYearsList[i].this_groups_member;
              obj['增幅'] = this.memberChangeThreeYearsList[i].groups_member_growth;
            }
            list.data.push(obj);
          }
        }
      }
      this.chartData = list;
      this.memberChangeThreeYearsCityChartOption = drawBar(list);

    },
    getOrgMemberChangeThreeYearsCity() {
      console.log(888, this.year);
      this.$api.member.getMemberChangeThreeYearsCity().then((res) => {
        let { data } = res.data;
        console.log('city', data);
        this.memberChangeThreeYearsCity = data.map(item =>{
          return {
            label: item,
            value: item,
          }
        });
        if (data) {
          this.selectMemberChangeThreeYearsCity = data[0];
          this.getOrgMemberChangeThreeYears();
        }
      });
    },
    changeTab(item, i) {
      console.log(item, i);
      this.memberChangeTabIndex = i;
      this.getOrgMemberChangeThreeYearsChart();
      // this.getData();
    },
    getCityEPerson() {
      console.log(888, this.year);
      console.log(888, this.cityEPersonSelectCity);
      this.$api.member.getCityEPerson({ city: this.cityEPersonSelectCity, year: this.year }).then((res) => {
        let { data } = res.data;
        console.log(888, data);
        this.cityEPersonList = data;
      });
    },
    getCityEPersonCity() {
      console.log(888, this.year);
      this.$api.member.getCityEPersonCity({year: this.year}).then((res) => {
        let { data } = res.data;
        console.log('city', data);
        this.cityEPersonCityList = data.map(item =>{
          return {
            label: item,
            value: item,
          }
        });
      });
    },
    getNationalFiveGood() {
      this.$api.member.getNationalFiveGood().then((res) => {
        let { data } = res.data;
        console.log(888, data);
        this.nationalFiveGoodList = data.tableData;
        this.nationalFiveGoodTotal = data.totalData;
        this.fiveGoodTabIndex = 0;
        this.showFiveTableList = this.nationalFiveGoodList;
      });
    },
    getProvincesFiveGood() {
      this.$api.member.getProvincesFiveGood().then((res) => {
        let { data } = res.data;
        console.log(888, data);
        this.provincesFiveGoodList = data.tableData;
        this.provincesFiveGoodTotal = data.totalData;
      });
    },
    fiveGoodChangeTab(item, i) {
      console.log(item, i);
      this.fiveGoodTabIndex = i;
      if (i === 0) {
        this.showFiveTableList = this.nationalFiveGoodList;
      } else if (i === 1) {
        this.showFiveTableList = this.provincesFiveGoodList;
      }
    },
    getCocChangeThreeYear() {
      console.log(888, this.selectCocChangeThreeYearsCity);
      this.$api.member.getCocChangeThreeYear({ city: this.selectCocChangeThreeYearsCity }).then((res) => {
        let { data } = res.data;
        console.log(888, data);
        this.cocChangeThreeYearsList = data;
        if (data) {
          this.getCocChangeThreeYearChart();
        }
      });
    },
    getCocChangeThreeYearCity() {
      this.$api.member.getCocChangeThreeYearCity().then((res) => {
        let { data } = res.data;
        console.log('city', data);
        this.cocChangeThreeYearsCity = data.map(item =>{
          return {
            label: item,
            value: item,
          }
        });
        if (data){
          this.selectCocChangeThreeYearsCity = data[0];
          this.getCocChangeThreeYear();
        }
      });
    },
    getCocChangeThreeYearChart() {
      let names = ['镇街商会数'];
      let list = {
        yAxis: {
          names: ['单位：个'],
        },
        names: Array.from(names),
        data: [],
      };
      list.names = names;
      list.showLabel = true;
      if (this.cocChangeThreeYearsList) {
        for (let i = 0; i < this.cocChangeThreeYearsList.length; i++) {
          if (this.cocChangeThreeYearsList[i].year){
            let obj = {};
            obj['年份'] = (this.cocChangeThreeYearsList[i].year);
            obj['镇街商会数'] = (this.cocChangeThreeYearsList[i].town_street_chambers_of_commerce_amount);
            list.data.push(obj);
          }
        }
      }
      // this.chartData = list;
      console.log(list);
      this.cocChangeThreeYearChartOption = drawOneBar(list);
    },
    showModal(index, item) {
      this.$emit("showModal", index);
      // if (index === 0){
      //   this.showOrgDev = true;
      //   this.getOrgDevData();
      // } else if (index === 1) {
      //   this.memberDevInfoShow = true;
      //   this.getMemberDevData();
      //   this.getMemberTopFiveData();
      //   this.getMemberGrowthTopThreeData();
      //   this.getOrgMemberChangeThreeYearsCity();
      // } else if (index === 2 || index === 3) {
      //   this.workerListShow = true;
      //   this.getCityEPersonCity();
      //   this.getCityEPerson();
      // } else if (index === 4) {
      //   this.fiveGoodListShow = true;
      //   this.getNationalFiveGood();
      //   this.getProvincesFiveGood();
      // } else if (index === 5) {
      //   this.cocChangeThreeYearInfoShow  =true;
      //   this.getCocChangeThreeYearCity();
      // }

      // console.log(item);
      // if (index === 0) {
      //   this.itemIndex = index;
      //   this.dialogTitle = '企业帮扶统计';
      //   if (!item.unSet) {
      //     this.search = {
      //       city: '全省',
      //       entName: null,
      //     };
      //   }
      //   this.refreshPage();
      // } else if (index < 3) {
      //   this.itemIndex = 1;
      //   this.dialogTitle = '项目管理';
      //   if (!item.unSet) {
      //     this.search = {
      //       city: '全省',
      //       entName: '',
      //     };
      //     this.refreshPage();
      //   }
      // } else return;
      // this.showDialog = true;
    },

    filterData(data, name, keyName, label) {
      let arr = [];
      for (let key = 0; key < data.length; key++) {
        if (data[key][label] === name) {
          arr.push(Number(data[key][keyName]));
        }
      }
      return arr;
    },
    setInterData() {
      this.$nextTick(() => {
        this.$refs['bar-chart'].clear();

        this.chartOption = drawBar(this.chartData, true);
      });
    },
    showItemInfo() {
      this.itemIndex = 2;
      this.showDialog = true;
      this.dialogTitle = '项目详情';
      this.refreshPage();
    },

    refreshPage() {
      let dy = {};
      if (this.search.city && this.search.city !== '全省') dy.city = this.search.city + '市';
      if (this.search.entName) dy.entName = this.search.entName;
      console.log(778, this.search);
      switch (this.itemIndex) {
        case 0:
          this.$api.market
            .getLxshzrDetailList({
              year: this.year,
              pageNum: this.pager.currentPage,
              pageSize: 10,
              ...dy,
            })
            .then((res) => {
              if (res.data.data) {
                this.tableData = res.data.data.records;
                this.pager.total = res.data.data.total;
              } else {
                this.tableData = [];
                this.pager.total = 0;
              }
            });
          break;
        case 1:
          // dy.c_begineat = this.year;
          // if (this.search.id) {
          //   dy.r_enterpresebase_id = this.search.id;
          //   this.getProjectList(dy);
          // } else if (this.search.entName) {
          this.$api.market
            .getLxshzrDetailProject(
              {
                year: this.year,
                ...this.search,
                pageCurrent: this.pager.currentPage,
                pageSize: 10,
              },
              [],
              {
                showMsg: false,
              },
            )
            .then((res) => {
              this.tableData = res.data.data.records;
              this.pager.total = res.data.data.total;
              // if (res.data.data) {
              //   dy.r_enterpresebase_id = res.data.data[0].c_id;
              // }
              // this.getProjectList(dy);
            });
          // } else this.getProjectList(dy);

          break;
        case 2:
          this.tableData = [];
          let x = this.curData;
          this.$api.market
            .getLxshzrDetailProjectReport(
              {
                projectId: this.search.projectId,
              },
              [],
              {
                showMsg: false,
              },
            )
            .then((r) => {
              this.tableData = r.data.data.data.map((x) => ({
                ...x,
                c_projectstatus: +x.c_projectstatus ? '已竣工' : '进行中',
              }));
              console.log(r.data.data, this.curData, 1009);
              let x = this.curData;
              this.itemData = {
                ...x,
                c_planat: x.c_planat ? getTime(new Date(x.c_planat), 'yyyy-MM-dd') : '-',
                c_endat: x.c_endat ? getTime(new Date(x.c_endat), 'yyyy-MM-dd') : '-',
                c_begineat: x.c_begineat ? getTime(new Date(x.c_begineat), 'yyyy-MM-dd') : -'',
                r_enterpresebase_id: r.data.data.data[0]?.c_entname || '-',
                c_status: +x.c_status ? '已竣工' : '进行中',
              };
              // console.log(this.tableData);
            });
          // this.$api.common
          //   .getFormData(
          //     {
          //       dynamicConditions: {
          //         r_project_id: this.curData.c_id,
          //       },
          //       pageCurrent: this.pager.currentPage,
          //       pageSize: 10,
          //       syncFormId: 7,
          //     },
          //     [],
          //     {
          //       showMsg: false,
          //     },
          //   )
          //   .then((r) => {
          //     console.log(r.data.data.records[0]);
          //     this.tableData = r.data.data.records.map((x) => ({
          //       ...x,
          //       c_projectstatus: Number(x.c_projectstatus) ? '已竣工' : '进行中',
          //     }));
          //     this.pager.total = r.data.data.total;
          //     // .push({
          //     //   ...res.data.data.records[0],
          //     //   r_enterpresebase_id: r.data.data.records[0].c_entname,
          //     // });
          //     // console.log(this.tableData);
          //   });
          break;
        default:
          break;
      }
    },
    getProjectList(dy) {
      this.tableData = [];
      // this.$api.common
      //   .getFormData(
      //     {
      //       dynamicConditions: dy,
      //       pageCurrent: this.pager.currentPage,
      //       pageSize: 10,
      //       syncFormId: 8,
      //     },
      //     [],
      //     {
      //       showMsg: false,
      //     },
      //   )
      //   .then((res) => {
      //     res.data.data.records.map((x) => {
      //       this.$api.market
      //         .getVillageEnterprise(
      //           {
      //             dynamicConditions: {
      //               c_id: x.r_enterpresebase_id,
      //             },
      //             pageCurrent: 1,
      //             pageSize: 1,
      //             syncFormId: 9,
      //           },
      //           [],
      //           {
      //             showMsg: false,
      //           },
      //         )
      //         .then((r) => {
      //           console.log(r);
      //           if (r.data.data) {
      //             this.tableData.push({
      //               ...x,
      //               c_entname: r.data.data[0].c_entname,
      //             });
      //           } else {
      //             this.tableData.push(x);
      //           }
      //           console.log(this.tableData);
      //         });
      //     });
      //     this.pager.total = res.data.data.total;
      //   });
    },
    handleSizeChange(e) {
      this.pager.pageSize = e;
      this.refreshPage();
    },
    handleCurrentChange(e) {
      console.log(e);
      this.pager.currentPage = e;
      this.refreshPage();
    },
  },
  mounted() {
    // this.getData();
  },
};
</script>

<style lang="less" scoped>
.chart-bar-o {

  //.chart-box();
  //height: 100%;
  height: 399px;
  width: 100%;
  .title {
    width: 100%;
    div {
      flex: 1;
      justify-content: flex-end;
      display: inline-flex;
      line-height: 1;
      align-items: center;
      .element-select {
        position: unset;
      }
    }
    #btn-link {
      margin-left: 32px;
    }
  }
  .chart-con {
    &.unsetover {
      overflow: unset;
      height: auto;
      padding-left: 12px;
    }
    .item {
      width: 176px;
      height: 120px;
      display: inline-flex;
      flex-direction: column;
      padding: 50px 0 0 99px;
      box-sizing: border-box;
      cursor: pointer;
      &.item-0 {
        width: calc(100% - 500px);
        background: url('~img/member/organization-profile-left-1.png') left bottom no-repeat;
        background-size: 96px 96px;
      }
      &.item-1 {
        width: calc(100% - 500px);
        background: url('~img/member/organization-profile-right-1.png') left bottom no-repeat;
        background-size:  96px 96px;
      }
      &.item-2 {
        width: calc(100% - 500px);
        background: url('~img/member/organization-profile-left-2.png') left bottom no-repeat;
        background-size:  96px 96px;
      }
      &.item-3 {
        width: calc(100% - 500px);
        background: url('~img/member/organization-profile-right-2.png') left bottom no-repeat;
        background-size:  96px 96px;
      }
      &.item-4 {
        width: calc(100% - 500px);
        background: url('~img/member/organization-profile-left-3.png') left bottom no-repeat;
        background-size:  96px 96px;
      }
      &.item-5 {
        width: calc(100% - 500px);
        background: url('~img/member/organization-profile-right-3.png') left bottom no-repeat;
        background-size:  96px 96px;
      }
      .line {
        display: inline-flex;
        align-items: center;
        justify-content: space-between;
        padding-right: 59px;
        + .line {
          margin-top: 6px;
        }
        .item-value {
          margin: 0;
        }
      }
      .item-label {
        font-family: Microsoft YaHei;
        font-weight: 400;
        font-size: 20px;
        color: #ffffff;
        line-height: 1;
        text-shadow: 1px 2px 0px rgba(17, 20, 22, 0.22);
        font-style: italic;
      }
      .item-value {
        white-space: nowrap;
        line-height: 1;
        margin-top: 7px;
        b {
          font-family: Geometr706 BlkCn BT;
          font-weight: 900;
          font-size: 26px;
          color: #ffffff;
          font-style: italic;
          background: linear-gradient(0deg, #8bb4d0 0%, rgba(255, 255, 255, 1) 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          padding-right: 3px;
        }
        span {
          font-size: 18px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #eff0f1;
          // line-height: 29px;
          opacity: 0.6;
          margin-left: 12px;
          white-space: nowrap;
        }
      }
    }
  }
  .sub-title {
    padding: 20px 9px 18px 10px;
    font-size: 22px;
    color: #eff0f1;
    line-height: 25px;
    display: flex;
    justify-content: space-between;
    position: relative;
    &::before {
      width: 100%;
      height: 18px;
      content: ' ';
      display: block;
      position: absolute;
      bottom: 20px;
      left: 10px;
      background: linear-gradient(90deg, rgba(#0083ad, 1) 0%, rgba(#0083ad, 0) 40%);
      z-index: -1;
      transform: skewX(-40deg);
    }
    // &::after {
    //   width: 0;
    //   height: 0;
    //   content: ' ';
    //   display: block;
    //   position: absolute;
    //   position: absolute;
    //   bottom: 20px;
    //   left: 10px;
    //   border: 20px solid transparent;
    //   border-left-color: #000;
    // }
    span {
      padding-left: 20px;
    }
    div {
      display: inline-flex;
      line-height: 1;
      align-items: center;
    }
    #btn-link {
      margin-left: 12px;
    }
  }
  .cursor-pointer {
    cursor: pointer
  }
  .text-align-right {
    text-align: right;
  }
  /deep/ .tab-list {
    margin: 5px 0 0;
    .list {
      position: unset;
    }
  }

  /deep/ .ele-dialog {
    .item-label {
      font-family: Microsoft YaHei;
      font-weight: 400;
      font-size: 22px;
      color: #ffffff;
      line-height: 1;
      text-shadow: 1px 2px 0px rgba(17, 20, 22, 0.22);
      font-style: italic;
      b {
        font-size: 26px;
      }
      .comment-font {
        font-family: Microsoft YaHei;
        font-weight: 400;
        font-size: 16px;
        color: #CE5E03FF;
        line-height: 1;
        text-shadow: 1px 2px 0px rgba(17, 20, 22, 0.22);
        font-style: italic;
      }
    }
    .item-value {
      white-space: nowrap;
      line-height: 1;
      margin-top: 7px;
      b {
        font-family: Geometr706 BlkCn BT;
        font-weight: 900;
        font-size: 22px;
        color: #ffffff;
        font-style: italic;
        background: linear-gradient(0deg, #8bb4d0 0%, rgba(255, 255, 255, 1) 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        padding-right: 3px;
      }
      span {
        font-size: 12px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #eff0f1;
        // line-height: 29px;
        opacity: 0.6;
        margin-left: 12px;
        white-space: nowrap;
      }
    }
    &.info-modal {
      .item-title {
        position: relative;
        perspective: 100px;
        margin-bottom: 28px;
        height: 25px;
        &::after {
          position: absolute;
          left: 0;
          bottom: 0;
          content: attr(data-title);
          font-size: 18px;
          font-family: Adobe Heiti Std;
          font-weight: normal;
          color: #eff0f1;
          line-height: 24px;
          padding-left: 10px;
        }
        &.YouSheTitle::after {
          font-family: 'YouSheTitle';
          font-weight: 400;
          font-size: 26px;
        }
        &::before {
          position: absolute;
          left: 0;
          bottom: 0;
          width: 100%;
          height: 20px;
          background: linear-gradient(90deg, #328cbb 0%, rgba(50, 140, 187, 0.5) 10%, transparent 100%);
          content: '';
          display: block;
          transform: rotateX(8deg);
          perspective-origin: right top;
        }
      }

      .item-content {
        width: 100%;
        height: auto !important;
        align-items: flex-start;
        box-sizing: border-box;
        border-image: linear-gradient(180deg, #071322, #225087) 10 10;
        // background: linear-gradient(
        //   90deg,
        //   rgba(38, 69, 103, 0.4) 0%,
        //   rgba(61, 110, 167, 0.4) 47%,
        //   rgba(38, 69, 103, 0.4) 100%
        // );
        border-radius: 4px;
        margin-bottom: 41px;
        padding: 23px 20px 31px 41px;
        ul.content-ul {
          padding: 0;
          margin: 0;
          list-style: none;
          max-width: calc(100% / 3);

          + ul {
            position: relative;
            padding-left: 43px;
            &::before {
              position: absolute;
              left: 0;
              top: 0;
              width: 2px;
              height: 100%;
              background: #2c4c73;
              box-shadow: 1px 0px 2px 0px rgba(20, 34, 51, 0.5);
              content: '';
              display: inline-block;
            }
          }
          li {
            display: flex;
          }
          .li-label {
            font-size: 16px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #dcdcdc;
            line-height: 30px;
            margin-right: 22px;
            text-wrap: nowrap;
          }
          .li-value {
            font-size: 16px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: #ffffff;
            line-height: 30px;
          }
        }
      }
    }

    &.company-profile .el-dialog {
      width: 2144px;
      height: 806px;
      .el-dialog__body {
        padding: 0;
        height: calc(100% - 55px);
        .item-content {
          // padding: 0;
        }
      }
    }
    &.org-dev .el-dialog {
      height: calc(100% - 1200px);
      .el-dialog__body {
        height: calc(100% - 220px);
      }
      .a-class {
        font-family: Microsoft YaHei;
        font-weight: 400;
        font-size: 22px;
        color: #ffffff;
      }
    }

    &.org-info .el-row {
      padding-top: 30px;
    }
    .el-table {
      background: #2c4c73;
    }
    .el-table__expand-icon {
      color: #ffffff
    }
    &.member-dev .echarts {
      padding-top: 10px;
      width: 100%;
      height: 250px;
    }
    &.five-good .tab-item {
      font-size: 22px;
    }
    &.coc-change-three-year .echarts {
      width: 100%;
      height: 300px;
    }


  }
}
</style>
